import React from 'react';
import { Space, Input, Select, Button } from 'antd';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';

const { Option } = Select;

export interface SupportFiltersValues {
  status?: string;
  priority?: string;
  category?: string;
  assignee?: string;
  source?: 'MERCHANT' | 'USER';
  q?: string;
}

interface FiltersBarProps {
  values: SupportFiltersValues;
  onChange: (values: SupportFiltersValues) => void;
  onSearch: () => void;
  onReset: () => void;
  loading?: boolean;
  currentAdminId?: number | null;
}

const STATUS_OPTIONS = [
  { value: '', label: 'Tất cả trạng thái' },
  { value: 'OPEN', label: 'Mới' },
  { value: 'IN_PROGRESS', label: 'Đang xử lý' },
  { value: 'WAITING_CUSTOMER', label: 'Cần phản hồi' },
  { value: 'RESOLVED', label: 'Đã giải quyết' },
  { value: 'CLOSED', label: 'Đã đóng' },
];

const PRIORITY_OPTIONS = [
  { value: '', label: 'Tất cả mức độ' },
  { value: 'LOW', label: 'Thấp' },
  { value: 'MEDIUM', label: 'Trung bình' },
  { value: 'HIGH', label: 'Cao' },
  { value: 'URGENT', label: 'Khẩn cấp' },
];

const SOURCE_OPTIONS = [
  { value: '', label: 'Tất cả nguồn' },
  { value: 'MERCHANT', label: 'Merchant' },
  { value: 'USER', label: 'User' },
];

const ASSIGNEE_OPTIONS = (
  currentAdminId: number | null | undefined
): Array<{ value: string; label: string }> => {
  const base = [
    { value: '', label: 'Tất cả' },
    { value: 'unassigned', label: 'Chưa gán' },
  ];
  if (currentAdminId != null) {
    base.push({ value: String(currentAdminId), label: 'Gán cho tôi' });
  }
  return base;
};

export const FiltersBar: React.FC<FiltersBarProps> = ({
  values,
  onChange,
  onSearch,
  onReset,
  loading,
  currentAdminId,
}) => {
  return (
    <Space wrap size="middle" style={{ marginBottom: 16 }}>
      <Input
        placeholder="Tìm theo mã ticket, tiêu đề..."
        prefix={<SearchOutlined />}
        value={values.q ?? ''}
        onChange={e => onChange({ ...values, q: e.target.value })}
        onPressEnter={onSearch}
        style={{ width: 260 }}
        allowClear
      />
      <Select
        placeholder="Trạng thái"
        value={values.status ?? ''}
        onChange={v => onChange({ ...values, status: v || undefined })}
        style={{ width: 160 }}
      >
        {STATUS_OPTIONS.map(o => (
          <Option key={o.value || 'all'} value={o.value}>
            {o.label}
          </Option>
        ))}
      </Select>
      <Select
        placeholder="Ưu tiên"
        value={values.priority ?? ''}
        onChange={v => onChange({ ...values, priority: v || undefined })}
        style={{ width: 140 }}
      >
        {PRIORITY_OPTIONS.map(o => (
          <Option key={o.value || 'all'} value={o.value}>
            {o.label}
          </Option>
        ))}
      </Select>
      <Select
        placeholder="Nguồn"
        value={values.source ?? ''}
        onChange={v =>
          onChange({
            ...values,
            source: v === 'MERCHANT' || v === 'USER' ? v : undefined,
          })
        }
        style={{ width: 140 }}
      >
        {SOURCE_OPTIONS.map(o => (
          <Option key={o.value || 'all'} value={o.value}>
            {o.label}
          </Option>
        ))}
      </Select>
      <Select
        placeholder="Người xử lý"
        value={values.assignee ?? ''}
        onChange={v => onChange({ ...values, assignee: v || undefined })}
        style={{ width: 160 }}
      >
        {ASSIGNEE_OPTIONS(currentAdminId).map(o => (
          <Option key={o.value || 'all'} value={o.value}>
            {o.label}
          </Option>
        ))}
      </Select>
      <Button type="primary" onClick={onSearch} loading={loading}>
        Tìm kiếm
      </Button>
      <Button icon={<ReloadOutlined />} onClick={onReset}>
        Tải lại
      </Button>
    </Space>
  );
};
